import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  set,
  push,
  get,
  serverTimestamp,
  onValue,
} from "firebase/database";
import ReactAudioPlayer from "react-audio-player";

function Podcast(props) {
  const [podcastDetails, setPodcastDetails] = useState({});
  const firebaseConfig = {
    apiKey: "AIzaSyB7D3p41RmiAOp_cbFJB2pUPb9a33J4IPI",
    authDomain: "aipodcastmania.firebaseapp.com",
    databaseURL: "https://aipodcastmania-default-rtdb.firebaseio.com",
    projectId: "aipodcastmania",
    storageBucket: "aipodcastmania.appspot.com",
    messagingSenderId: "514246671749",
    appId: "1:514246671749:web:7cf93b54e798c8be8d58ec",
    measurementId: "G-XKJ38EFBKN",
  };

  const app = initializeApp(firebaseConfig);
  const db = getDatabase(app);

  const { podcastID } = useParams();

  useEffect(() => {
    const dbRef = ref(db, `podcasts/${podcastID}`);
    onValue(dbRef, (snapshot) => {
      const data = snapshot.val();
      // turn data into an array

      setPodcastDetails({ ...data });
    });
  }, []);

  return (
    <div className="flex flex-col items-center justify-center">
      {podcastDetails.result && (
        <>
          <h1 className="text-pink-300">{podcastDetails.prompt.trim()}</h1>
          <span className="text-sm">
            a podcast created using PodcastMania.US
          </span>

          {podcastDetails.downloadURL && (
            <div className="flex flex-row my-4 justify-center items-center w-full">
              {/* <p className="text-black">{downloadURL}</p> */}
              <ReactAudioPlayer
                className="audio"
                src={podcastDetails.downloadURL}
                autoPlay
                controls
              />
            </div>
          )}

          <div className="flex flex-row justify-start sm:w-5/6 md:w-3/4 lg:w-3/4 xl:w-1/2">
            <h1
              style={{ color: "#FF66C4" }}
              className="text-left text-lg font-bold w-full justify-start"
            >
              Transcript:
            </h1>
          </div>
          <div className="flex flex-col justify-start max-h-96 overflow-y-scroll sm:w-5/6 md:w-3/4 lg:w-3/4 xl:w-1/2">
            <p className="text-left text-black text-sm px-8">
              {podcastDetails.result.split("\n").map((item, i) => {
                return (
                  <span style={{ color: "white" }} key={i}>
                    {item}
                    <br />
                  </span>
                );
              })}
            </p>
          </div>
        </>
      )}
      {!podcastDetails.result && (
        <div className="flex flex-col items-center justify-center">
          <h1 className="text-pink-300">Loading...</h1>
        </div>
      )}
    </div>
  );
}

export default Podcast;
